import "../../../../assets/css/AddCatalogs.css";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CatalogSubTitle from "../../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import RadioButton from "../../../../components/Atomos/Radio/RadioButton";
import EditFirmWide from "./EditFirmWide";
import { Tab } from "@headlessui/react";
import EditMembershipLocation from "./EditMembershipLocation";
import SaveOverride from "../../../../components/Catalogs/SaveOverride";
import { useManageFirmContactPageState } from "../../../../hooks/ManageFirm/useManageFirmContactPageState";

const ManageFirmContact: React.FC = () => {
  const { id: firmId } = useParams<{ id: string }>();
  const { mergedState } =
    useManageFirmContactPageState(firmId);

  const [selectedOption, setSelectedOption] = useState(0);
  const [buttonClicked, setButtonClicked] = useState("");
  const [update, setUpdate] = useState(false);
  const [selectedTab, setSelectedTab] = useState("");
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [errorJurisdiction, setErrorJurisdictions] = useState<string[]>([]);
  const [saveOverrideOpen, setSaveOverrideOpen] = useState(false);
  const [jurisdictionsIds, setJurisdictionsIds] = useState<any[]>([]);

  useEffect(() => {
    if (!mergedState?.firmContact) {
      return;
    }
    setSelectedOption(mergedState.firmContact.level ? 0 : 1);
    const firstJur =
      mergedState.firmContact.jurisdictions?.[0]?.jurisdiction ?? "";
    setSelectedTab((prev) =>
      prev && mergedState.firmContact?.jurisdictions?.some(
        (j: any) => j.jurisdiction === prev
      )
        ? prev
        : firstJur
    );
  }, [mergedState?.firmContact, firmId]);

  const handleButtonClick = (buttonName: string) => {
    setButtonClicked(buttonName);
  };

  const checkEditType = (index: number) => {
    setSelectedOption(index);
  };

  useEffect(() => {
    if (errorFields.length > 0) {
      setSaveOverrideOpen(true);
    }
    if (errorFields.length === 0 && errorJurisdiction.length === 0) {
      setSaveOverrideOpen(false);
    }
  }, [errorFields]);

  useEffect(() => {
    if (errorJurisdiction.length > 0) {
      setSaveOverrideOpen(true);
    }
    if (errorJurisdiction.length === 0 && errorFields.length === 0) {
      setSaveOverrideOpen(false);
    }
  }, [errorJurisdiction]);

  const handleTabValue = (jurisdiction: any) => {
    setSelectedTab(jurisdiction);
  };

  const handleCloseSaveOverride = () => {
    setSaveOverrideOpen(!saveOverrideOpen);
  };

  useEffect(() => {
    const firmJurisdiction = mergedState?.jurisdictionList?.filter(
      (jur: any) =>
        jur.jurisdictionGroup === mergedState?.jurisdictionGroup ||
        jur.jurisdictionGroup === mergedState?.jurisdictionGroupId
    );
    setJurisdictionsIds(firmJurisdiction ?? []);
  }, [
    mergedState?.jurisdictionList,
    mergedState?.jurisdictionGroup,
    mergedState?.jurisdictionGroupId,
  ]);

  const ready = Boolean(
    mergedState?.id === firmId &&
      mergedState?.name &&
      mergedState?.firmContact
  );

  const state = mergedState;

  return (
    <>
      <div className="flex flex-col gap-5 md:gap-6 lg:gap-7">
        <SaveOverride
          fields={[...errorFields, ...errorJurisdiction]}
          handleButtonClick={handleButtonClick}
          open={saveOverrideOpen}
          close={handleCloseSaveOverride}
          noSaveOverride={true}
        />
      </div>
      <div className="relative flex flex-col gap-10 justify-end">
        <article className="articleSection">
          <section className="formsectionNTitle">
            <div className="flex flex-col md:flex-row w-full justify-between gap-2">
              <CatalogSubTitle
                title={`Internal ${state?.name ?? ""} Contact for WSG`}
                className="text-Default text-[26px] md:text-[34px] lg:text-[42px] not-italic font-medium lg:leading-[44px] md:leading-[48px] leading-normal"
              />
            </div>
          </section>
          <div className="flex flex-col lg:flex-row lg:items-center w-full gap-5">
            <span className="text-gray-font not-italic leading-6 font-bold text-[22px]">
              Firm Contact Structure:
            </span>
            <RadioButton
              index={0}
              text={"Contacts defined Firm Wide"}
              selected={selectedOption === 0}
              handleRadioButtonChange={checkEditType}
              disabled={true}
            />
            <RadioButton
              index={1}
              text={"Contacts defined by Membership Locations"}
              selected={selectedOption === 1}
              handleRadioButtonChange={checkEditType}
              disabled={true}
            />
          </div>
          <div className="w-full">
            {selectedOption === 0 && (
              <EditFirmWide
                buttonClicked={buttonClicked}
                update={update}
                setUpdate={setUpdate}
                firmContact={state?.firmContact ?? {id: "", contacts: []}}
                setErrorFields={setErrorFields}
                state={state}
              />
            )}
            {selectedOption === 1 && (
              <>
                <Tab.Group>
                  <Tab.List
                    className={
                      "grid md:grid-cols-3 lg:gap-0 lg:grid-cols-6 pb-4"
                    }
                  >
                    {state?.firmContact?.jurisdictions?.map(
                      (jurisdiction: any, index: number) => {
                        return (
                          <Tab
                            key={index}
                            onClick={() =>
                              handleTabValue(jurisdiction.jurisdiction)
                            }
                            className={` justify-center items-center col-span-1 bg-[#E5E3E4] max-h-[190px] text-gray-font ui-selected:text-neutral p-3 pr-2 ui-selected:bg-accent-Default-dark border-none rounded-none focus:border-none`}
                          >
                            <span
                              className={` not-italic text-lg leading-8 font-normal`}
                            >
                              {state?.jurisdictionList?.find(
                                (jur: any) =>
                                  jur.id === jurisdiction.jurisdiction
                              )?.name ?? "undefined"}
                            </span>
                          </Tab>
                        );
                      }
                    )}
                  </Tab.List>
                </Tab.Group>
                <EditMembershipLocation
                  jurisdictionId={selectedTab}
                  jurisdictionName={
                    state?.jurisdictionList?.find(
                      (jur: any) => jur.id === selectedTab
                    )?.name
                  }
                  jurisdictionsIds={jurisdictionsIds}
                  setErrorFields={setErrorFields}
                  setErrorJurisdiction={setErrorJurisdictions}
                  buttonClicked={buttonClicked}
                />
              </>
            )}
          </div>
        </article>
      </div>
    </>
  );
};

export default ManageFirmContact;
